import type Context from '@/context';
import type { IChipModel, IEditorModel } from '@/interfaces/models';
import { EditorModel } from '@/models/EditorModel';
import { TileSelectModelFactory } from '@/factories/TileSelectModelFactory';
import { ChipSelectModelFactory } from '@/factories/ChipSelectModelFactory';

export class EditorModelFactory {
  constructor(
    private readonly tileSelectModelFactory: TileSelectModelFactory,
    private readonly chipSelectModelFactory: ChipSelectModelFactory,
  ) {}

  create(context: Context, currentChip: IChipModel): IEditorModel {
    const tileSelectModel = this.tileSelectModelFactory.create(context);
    const chipSelectModel = this.chipSelectModelFactory.create(context);

    return new EditorModel(context, {
      tileSelectModel,
      chipSelectModel,
      currentChip,
    });
  }
}
